import React, { useState } from "react";
import useStore from "../store/useStore";
import ButtonOrang from "../components/ButtonOrang";

export default function VideoBackground({
  video,
  titulo1,
  titulo2,
  textbutton,
  link,
  logo,
  cartel,
}) {
  const setVideoUrlError = useStore((state) => state.setVideoUrlError);
  const videoPlaceholder = useStore((state) => state.videoPlaceholder);
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [videoError, setVideoError] = useState(false);

  return (
    <div className="relative w-full h-screen mt-[60px] md:mt-0 overflow-hidden flex items-center p-6 justify-start">
      {(!videoLoaded || videoError) && (
        <img
          src={videoPlaceholder}
          alt="Cargando video"
          className="absolute top-0 left-0 w-full h-full object-cover z-0"
        />
      )}

      {!videoError && (
        <video
          className="absolute top-0 left-0 w-full h-full object-cover z-0"
          autoPlay
          loop
          muted
          onCanPlay={() => setVideoLoaded(true)}
          onLoadedData={() => setVideoLoaded(true)}
          onError={() => {
            setVideoUrlError("No se pudo cargar el video");
            setVideoError(true);
          }}
        >
          <source src={video} type="video/mp4" />
        </video>
      )}

      <div className="absolute top-0 left-0 w-full h-full z-1 pointer-events-none bg-gradient-to-t from-sidom-orange to-transparent to-30%" />

      <div className="absolute container    z-10">
        <div className="flex flex-col md:flex-col lg:flex-row justify-center items-center gap-1   md:gap-52  lg:gap-64 ">
          <div className=" w-full  lg:w-screen leading-[1.3]">
            <h1 className="text-sidom-light  text-wrap text-4xl md:text-6xl lg:text-4xl xl:text-5xl font-bold mb-4">
              {titulo1}
            </h1>
            <p className="text-sidom-light   text-2xl mb-8">{titulo2}</p>
            {cartel && cartel}
            <div className="mb-10 md:mb-0">
              <ButtonOrang
                text={textbutton}
                background="bg-sidom-orange"
                textColor="text-sidom-light"
                bloke={true}
                link={link}
              />
            </div>
          </div>
          <div className="  relative flex justify-center items-center w-[100%] md:w-[60%] lg:w[60%] m-auto   z-10">
            <img
              src={logo}
              alt="Imagen  de fondo"
              className=" w-[300px] animate-float"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
